import { useGetAllCardsFleet } from "../../../api/badge";
import { CustomLoader } from "../../../components/CustomLoader/CustomLoader";
import { CustomTable } from "../../../components/CustomTable/CustomTable";
import { getCurrentFleetId } from "../../../utils/getCurrentFleet";
import { useTranslation } from "react-i18next";
import { getColumnsCards } from "./columnsCards";
import { useServerPagination } from "../../../hooks/useServerPagination";
import { useMemo } from "react";

export const Cards = () => {
  const { t } = useTranslation();
  const pagination = useServerPagination();

  // Keye sur `t` : les en-tetes se reconstruisent au changement de langue.
  const columns = useMemo(() => getColumnsCards(t), [t]);
  const {
    cards,
    isPending: isPendingCards,
    totalCount,
  } = useGetAllCardsFleet(
    getCurrentFleetId(),
    pagination.page,
    pagination.perPage,
    pagination.search
  );

  return (
    <>
      {isPendingCards && <CustomLoader isActive={isPendingCards} />}

      <CustomTable
        columns={columns}
        data={cards}
        titleHeader={t("collaborator.cards", "Cards")}
        tableMaxHeight={"300px"}
        isSearchable
        isFilterFromBackend
        tablePagnationCount={totalCount}
        {...pagination.tableProps}
        // showSelectedField
        // componentHeader={
        //   <>
        //     <CustomButtonTable
        //       variant={"primary"}
        //       textVariant={"link"}
        //       label={t("common.groupeActions", "Groupe actions")}
        //       width={"fit-content"}
        //       fontWeight={"bold"}
        //       textDecoration={"none"}
        //       iconName={"chevronDown"}
        //       padding={"0px 15px"}
        //       textTransform="uppercase"
        //       endIcon
        //     />
        //   </>
        // }
      />
    </>
  );
};

export default Cards;
